import { createRef } from 'react';

import { AudioRouteButtonMethods } from './_types';

export const audioRouteButtonRef = createRef<AudioRouteButtonMethods>();
export const audioCallRemoteVideoRef = createRef<HTMLVideoElement>();
